export class TokenRefreshManager {
    constructor() {
        this.timers = new Map();
    }
    /**
     * Schedules refresh of token with provided id and relative token expiration time, using provided fetch operation
     */
    scheduleRefresh(tokenType, tokenExpiresInSec, fetchOperation, onTokenExpired) {
        let timer = this.timers.get(tokenType);
        if (!timer) {
            timer = { numberOfAttempts: 0 };
            this.timers.set(tokenType, timer);
        }
        if (timer.refreshTimeoutId) {
            clearTimeout(timer.refreshTimeoutId);
            timer.refreshTimeoutId = undefined;
        }
        if (timer.expiredTimeoutId) {
            clearTimeout(timer.expiredTimeoutId);
            timer.expiredTimeoutId = undefined;
        }
        let tokenRefreshOffset = tokenExpiresInSec * 1000 - TokenRefreshManager.tokenRefreshBufferMs;
        let tokenExpireOffset = tokenExpiresInSec * 1000 - TokenRefreshManager.tokenExpirationBufferMs;
        if (tokenRefreshOffset > 0) {
            timer.numberOfAttempts = 0;
        }
        else {
            // Offset being negative means that token is about to expire or it already expired and that we should schedule a refresh
            // We will increment number of attempts and adjust offset so that we do not attempt refresh more than once per tokenRefreshBackoffIntervalMs
            ++timer.numberOfAttempts;
            tokenRefreshOffset = TokenRefreshManager.tokenRefreshBackoffIntervalMs;
            tokenExpireOffset = TokenRefreshManager.tokenExpirationBufferMs;
        }
        if (timer.numberOfAttempts <= TokenRefreshManager.tokenRefreshMaximumAttempts) {
            timer.refreshTimeoutId = setTimeout(() => {
                fetchOperation();
            }, tokenRefreshOffset);
        }
        // if we do not get new token after tokenExpireOffset then invalidate existing token - call onTokenExpired()
        if (onTokenExpired) {
            timer.expiredTimeoutId = setTimeout(() => {
                onTokenExpired();
            }, tokenExpireOffset);
        }
    }
    clearRefreshTimeouts() {
        this.clearTimeouts(false);
    }
    clearAllTimeouts() {
        this.clearTimeouts(true);
    }
    clearTimeouts(clearExpireTimeouts) {
        this.timers.forEach((timer, key) => {
            if (timer.refreshTimeoutId) {
                clearTimeout(timer.refreshTimeoutId);
                timer.refreshTimeoutId = undefined;
            }
            if (clearExpireTimeouts && timer.expiredTimeoutId) {
                clearTimeout(timer.expiredTimeoutId);
                timer.expiredTimeoutId = undefined;
            }
            if (!timer.expiredTimeoutId) {
                this.timers.delete(key);
            }
        });
    }
}
TokenRefreshManager.tokenRefreshBufferMs = 1000 * 60 * 4; // 4 minutes
TokenRefreshManager.tokenExpirationBufferMs = 1000 * 60 * 2; // 2 minutes
TokenRefreshManager.tokenRefreshBackoffIntervalMs = 30000; // 30 seconds;
TokenRefreshManager.tokenRefreshMaximumAttempts = 3;
//# sourceMappingURL=token-refresh-manager.js.map